module.exports = __webpack_public_path__ + "static/media/circleterrase.91eab901.jpg";